import React from 'react'
import PropTypes from 'prop-types'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import CircularProgress from '@material-ui/core/CircularProgress'
import InfoChip from '../info-chip'
import { PagerStyled, NavButton } from './styled'

// Navegación entre candidaturas de la ficha: contador en InfoChip (solo números) y flechas de
// lucide en botones con borde neutro, como los ActionButton outlined de Velora
// Con `loading` (cambiando de candidatura) el contador muestra un spinner y las flechas se bloquean
const ProfilePager = ({ current, total, onPrevious, onNext, previousDisabled, nextDisabled, loading = false }) => (
  <PagerStyled className="no-print" aria-busy={loading}>
    <InfoChip
      label={loading ? <CircularProgress size={14} thickness={5} color="inherit" /> : `${current} / ${total}`}
      style={{ height: 32, minWidth: 64, fontSize: 14, fontVariantNumeric: 'tabular-nums', justifyContent: 'center' }}
    />
    <NavButton type="button" onClick={onPrevious} disabled={previousDisabled || loading} aria-label="previous">
      <ChevronLeft size={18} />
    </NavButton>
    <NavButton type="button" onClick={onNext} disabled={nextDisabled || loading} aria-label="next">
      <ChevronRight size={18} />
    </NavButton>
  </PagerStyled>
)

ProfilePager.propTypes = {
  current: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  previousDisabled: PropTypes.bool,
  nextDisabled: PropTypes.bool,
  loading: PropTypes.bool
}

export default ProfilePager
